import { NgModule } from '@angular/core';
import { RouteGuards } from '../../routes/route-guards/route-guards';
import { Auth } from './../auth/auth.service';
import { UtilitiesService } from './../services/utilities/utilities.service';
import { ApiHelpers } from './api-helpers';
import { ApiService } from './api-service/api-service';
import { BackgroundJobNotificationService } from './background-job-notification-service/background-job-notification-service';
import { CsvExporterService } from './csv-exporter/csv-exporter.service';
import { CsvImporterService } from './csv-importer/csv-importer-service';
import { DashboardCircleService } from './dashboard-circle-service/dashboard-circle-service';
import { DateHelpers } from './date-helpers/date-helpers.service';
import { ErrorToaster } from './error-toaster/error-toaster.service';
import { EventBus } from './event-bus/event-bus';
import { FormValidatorsService } from './form-validators/form-validators.service';
import { GraphQLActivitiesHelperService } from './graphql-helpers/activities/activities-queries.service';
import { GraphQLDataLoadsHelperService } from './graphql-helpers/data-loads/data-loads-queries.service';
import { GraphQLSchoolAssessmentsHelperService } from './graphql-helpers/school-assessments/school-assessments-queries.service';
import { GraphQLPartnerHelperService } from './graphql-helpers/partner/partner-queries.service';
import { GraphQlShelterClusterUserHelperService } from './graphql-helpers/user-management/cluster-user/shelter-cluster-user-queries.service';
import { GraphQLStudentActivitiesHelperService } from './graphql-helpers/student-activities/student-activities-queries.service';
import { GraphQLStudentAssessmentsHelperService } from './graphql-helpers/student-assessments/student-assessments-queries.service';
import { GraphQLClusterUserHelperService } from './graphql-helpers/user-management/cluster-user/cluster-user-queries.service';
import { ImModelsModule } from './im-models/im-models.module';
import { ListSummaryGroupings } from './list-summary-groupings/list-summary-groupings.service';
import { AssessmentsGrouping } from './mad-lib-services/grouping-functions/assessments/assessments-groupings';
import { CourseCodeGrouping } from './mad-lib-services/grouping-functions/course-code/course-code';
import { CoursePriorityGrouping } from './mad-lib-services/grouping-functions/course-priority/course-priority';
import { CourseRollupGrouping } from './mad-lib-services/grouping-functions/course-rollup/course-rollup';
import { HasOrNeedsSupportForCourseGrouping } from './mad-lib-services/grouping-functions/has-or-needs-support-for-course/has-or-needs-support-for-course';
import { HasOrNeedsSupportForSubjGrouping } from './mad-lib-services/grouping-functions/has-or-needs-support-for-subj/has-or-needs-support-for-subj';
import { ActivitiesGrouping } from './mad-lib-services/grouping-functions/postsec-groupings/activities-groupings';
import { StudentActivitiesGroupings } from './mad-lib-services/grouping-functions/postsec-groupings/student-activities-groupings';
import { SubjectRollupGrouping } from './mad-lib-services/grouping-functions/subject-rollup/subject-rollup';
import { TeacherRollupGrouping } from './mad-lib-services/grouping-functions/teacher-rollup/teacher-rollup';
import { MadLibGroupings } from './mad-lib-services/mad-lib-groupings';
import { MadLibHelpers } from './mad-lib-services/mad-lib-helpers';
import { MadLibSorting } from './mad-lib-services/mad-lib-sorting';
import { NotificationMessageParser } from './notification-message-parser/notification-message-parser.service';
import { ObjectCache } from './object-cache/object-cache.service';
import { ObjectHash } from './object-hash/object-hash.service';
import { PointPeopleService } from './point-people/point-people.service';
import { PortalConfig } from './portal-config';
import { PrevStateService } from './prev-state/prev-state.service';
import { PusherService } from './pusher/pusher-service';
import { PusherListeners } from './pusher/pusher-listeners';
import { RollupGroupingFooterService } from './rollup-grouping-footer-service/rollup-grouping-footer-service';
import { PathParserService } from './side-nav/path-parser.service';
import { SideNavService } from './side-nav/side-nav.service';
import { StudentCollectionsMergeService } from './student-collections-merge/student-collections-merge.service';
import { StudentFetchServicesModule } from './student-fetch/student-fetch.services.module';
import { StudentPanelPersistance } from './student-panel-persistance/student-panel-persistance.service';
import { SuccessToaster } from './success-toaster/success-toaster.service';
import { ToggleService } from './toggle/toggle.service';
import { UpgradedServicesModule } from './upgraded-services/upgraded.services.module';
import { UserAgentService } from './user-agent.service.ts/user-agent.service';
import { UserInactivity } from './user-inactivity/user-inactivity.service';
import { UserRolePermissionsForModelService } from './user-role-permissions-for-model/user-role-permissions-for-model.service';
import { WebStorageServicesModule } from './web-storage/web-storage.services.module';
import { WindowRef } from './windowRef';

@NgModule({
  imports: [UpgradedServicesModule, WebStorageServicesModule, StudentFetchServicesModule, ImModelsModule],
  providers: [
    Auth,
    DateHelpers,
    ApiService,
    ApiHelpers,
    EventBus,
    WindowRef,
    MadLibGroupings,
    // individual groupings
    ActivitiesGrouping,
    CourseRollupGrouping,
    TeacherRollupGrouping,
    SubjectRollupGrouping,
    HasOrNeedsSupportForSubjGrouping,
    HasOrNeedsSupportForCourseGrouping,
    CoursePriorityGrouping,
    CourseCodeGrouping,
    ListSummaryGroupings,
    StudentActivitiesGroupings,
    AssessmentsGrouping,

    NotificationMessageParser,
    SuccessToaster,
    ErrorToaster,
    UserRolePermissionsForModelService,

    MadLibHelpers,
    MadLibSorting,
    PusherService,
    PusherListeners,
    PortalConfig,
    ToggleService,
    SideNavService,
    StudentPanelPersistance,
    UserAgentService,
    PrevStateService,
    UtilitiesService,
    PathParserService,
    FormValidatorsService,
    PointPeopleService,
    StudentCollectionsMergeService,
    GraphQLDataLoadsHelperService,
    GraphQLStudentAssessmentsHelperService,
    GraphQLSchoolAssessmentsHelperService,
    GraphQLStudentActivitiesHelperService,
    GraphQLActivitiesHelperService,
    GraphQLClusterUserHelperService,
    GraphQLPartnerHelperService,
    GraphQlShelterClusterUserHelperService,
    // BackgroundJob,
    CsvExporterService,
    CsvImporterService,
    ObjectHash,
    ObjectCache,
    UserInactivity,
    RollupGroupingFooterService,
    DashboardCircleService,
    BackgroundJobNotificationService,
    RouteGuards,
  ],
})
export class SharedServicesModule {}
